<template>
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-safe pb-safe min-h-screen">
    <div class="py-4 flex items-center gap-4 border-b border-gray-200 mb-6">
      <NuxtLink to="/camera-rolls" class="text-blue-600 hover:text-blue-800 text-sm">
        &larr; Back
      </NuxtLink>
      <h1 class="text-xl font-semibold text-gray-900">Admin</h1>
      <div class="flex-1"></div>
      <nav class="flex gap-4">
        <NuxtLink to="/admin/upload" class="text-sm font-medium text-gray-600 hover:text-gray-900" active-class="text-blue-600 underline">
          Upload
        </NuxtLink>
        <NuxtLink to="/admin/users" class="text-sm font-medium text-gray-600 hover:text-gray-900" active-class="text-blue-600 underline">
          Users
        </NuxtLink>
        <NuxtLink to="/admin/invite" class="text-sm font-medium text-gray-600 hover:text-gray-900" active-class="text-blue-600 underline">
          Invite QR
        </NuxtLink>
      </nav>
    </div>
    <slot />
  </div>
</template>
